import InductionIcon from "@/assets/svg/induction.svg";
import InducteeIcon from "@/assets/svg/inductee.svg";
import EventIcon from "@/assets/svg/event.svg";
import PressIcon from "@/assets/svg/press.svg";
import ExhibitIcon from "@/assets/svg/exhibit.svg";
import NewsletterIcon from "@/assets/svg/newsletter.svg";
import FacebookIcon from "@/assets/svg/facebook.svg";
import SubstackIcon from "@/assets/svg/substack.svg";
import TikTokIcon from "@/assets/svg/tiktok.svg";
import YouTubeIcon from "@/assets/svg/youtube.svg";
import InstagramIcon from "@/assets/svg/instagram.svg";
import CantUnhearItIcon from "@/assets/svg/cant-unhear-it.svg";
import InteractiveIcon from "@/assets/svg/interactive.svg";
import RHTVIcon from "@/assets/svg/rhtv.svg";
import ShopIcon from "@/assets/svg/shop.svg";

export const PILL_ICONS: Record<string, React.FC<React.SVGProps<SVGSVGElement>>> = {
  'induction': InductionIcon,
  'inductee': InducteeIcon,
  'event': EventIcon,
  'press': PressIcon,
  'exhibit': ExhibitIcon,
  'newsletter': NewsletterIcon,
  'post': CantUnhearItIcon,
  'interactive': InteractiveIcon,
  'rhtv': RHTVIcon,
  'shop': ShopIcon,
}

export const SOCIAL_ICONS: Record<string, React.FC<React.SVGProps<SVGSVGElement>>> = {
  'facebook': FacebookIcon,
  'substack': SubstackIcon,
  'tikTok': TikTokIcon,
  'youtube': YouTubeIcon,
  'instagram': InstagramIcon
};